"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVanityName = getVanityName;
exports.openExpertInLinkedin = openExpertInLinkedin;

var _get = _interopRequireDefault(require("lodash/get"));

var _expert = _interopRequireDefault(require("../expert"));

var _idb = require("idb");

var uuid = _interopRequireWildcard(require("uuid"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var REQUESTS_TIMESTAMP = 2500;
var MAX_REQUESTS_EXECUTED = 1;
var RETRY_AFTER = 2;

var wait = function wait(s) {
  return new Promise(function (resolve) {
    setTimeout(resolve, s * 1000);
  });
};
/**
 * Decide whether to open a linkedin page or not,
 * depending on whether profile update blocks can occur,
 * and whether the expert already has a block in place.
 */


function openExpertInLinkedin(_x) {
  return _openExpertInLinkedin2.apply(this, arguments);
}
/**
 * Open a linkedin page.  Either the experts actual profile page
 * if they have a vanity name, or a search page if they don't.
 */


function _openExpertInLinkedin2() {
  _openExpertInLinkedin2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(expert) {
    var honorProfileUpdateBlock,
        requestUUID,
        db,
        requestsExecuted,
        transaction,
        store,
        timestamp,
        deleteKeyRange,
        requestsToLinkedIn,
        vn,
        blockable,
        _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            honorProfileUpdateBlock = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
            requestUUID = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
            if (!requestUUID) requestUUID = uuid.v4();
            _context.next = 5;
            return (0, _idb.openDB)('linkedin_ratelimit', 4, {
              upgrade: function upgrade(db) {
                try {
                  db.deleteObjectStore('linkedin_ratelimit');
                } catch (e) {}

                db.createObjectStore('linkedin_ratelimit', {
                  keyPath: 'timestamp'
                });
              }
            });

          case 5:
            db = _context.sent;
            requestsExecuted = 0;
            transaction = db.transaction('linkedin_ratelimit', 'readwrite');
            store = transaction.objectStore('linkedin_ratelimit');
            _context.prev = 9;
            timestamp = Date.now() - REQUESTS_TIMESTAMP;
            deleteKeyRange = IDBKeyRange.upperBound(Number(timestamp - REQUESTS_TIMESTAMP));
            _context.next = 14;
            return store["delete"](deleteKeyRange);

          case 14:
            _context.next = 16;
            return store.getAll();

          case 16:
            requestsToLinkedIn = _context.sent;
            requestsExecuted = requestsToLinkedIn.length;
            _context.next = 23;
            break;

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](9);
            return _context.abrupt("return", Promise.reject(_context.t0));

          case 23:
            if (!(requestsExecuted >= MAX_REQUESTS_EXECUTED)) {
              _context.next = 31;
              break;
            }

            _context.next = 26;
            return wait(RETRY_AFTER);

          case 26:
            _context.next = 28;
            return openExpertInLinkedin(expert, honorProfileUpdateBlock);

          case 28:
            return _context.abrupt("return", _context.sent);

          case 31:
            _context.next = 33;
            return store.add({
              timestamp: Date.now(),
              requestUUID: requestUUID
            });

          case 33:
            vn = getVanityName(expert);
            blockable = isProfileUpdateBlockable(expert, vn);

            if (vn && !vn.explicit) {
              _expert["default"].updateLinkedinVanityName(expert.id, vn.vanityName);
            }

            if (honorProfileUpdateBlock) {
              if (blockable) {
                _expert["default"].getProfileUpdateBlock(expert.id).then(function (result) {
                  if (!result.blocked) {
                    _openExpertInLinkedin(expert, vn, blockable);
                  }
                })["catch"](function (err) {});
              } else {
                _openExpertInLinkedin(expert, vn, blockable);
              }
            } else {
              _openExpertInLinkedin(expert, vn, blockable);
            }

          case 37:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 20]]);
  }));
  return _openExpertInLinkedin2.apply(this, arguments);
}

function _openExpertInLinkedin(expert, vn, blockable) {
  var baseUrl = window.location.protocol + '//' + window.location.host;

  if (vn) {
    var url = "https://www.linkedin.com/in/".concat(vn.vanityName, "?gtsn=1");
    window.postMessage({
      type: 'OPEN_TAB',
      url: url,
      tabData: {
        blockable: false,
        baseUrl: baseUrl
      }
    }, '*');
  } else {
    var _url = "https://www.linkedin.com/sales/search/people?doFetchHeroCard=true&keywords=".concat(expert.fullName);

    var companyName = getCompany(expert);

    if (companyName) {
      _url += " ".concat(companyName);
    }

    window.postMessage({
      type: 'OPEN_TAB',
      url: _url,
      tabData: {
        expertId: expert.id,
        expertFullName: expert.fullName,
        blockable: blockable,
        baseUrl: baseUrl
      }
    }, '*');
  }
}
/**
 * Returns the first company name from the expert's
 * experiences, if available and if not "not specified".
 */


function getCompany(expert) {
  var experiences = (0, _get["default"])(expert, 'cv.experiences', []);

  if (experiences.length) {
    var companyName = (0, _get["default"])(experiences[0], 'company.name', false);

    if (companyName && companyName.toLowerCase() !== 'not specified') {
      return companyName;
    }
  }

  return false;
}
/**
 * If there is an explicit vanity name then profile update cannot be blocked.
 * Otherwise, if they are a Health Care Professional and not in any other
 * sub-industry, then a profile update block is possible.
 */


function isProfileUpdateBlockable(expert, vn) {
  if (vn && vn.explicit) {
    return false;
  }

  var subIndustries = (0, _get["default"])(expert, 'expert.subIndustries', false);
  return subIndustries && subIndustries.length === 1 && subIndustries[0].id === 27;
}
/**
 * Check for an explicit vanity name.
 * If not available, check through professional link urls
 * and grab vanity name from there if possible.
 */


function getVanityName(expert) {
  var vanityName = (0, _get["default"])(expert, 'expert.linkedinVanityName', false);

  if (vanityName) {
    return {
      vanityName: vanityName,
      explicit: true
    };
  }

  var links = (0, _get["default"])(expert, 'links', false);

  if (links && links.length > 0) {
    for (var i = 0; i < links.length; i++) {
      if (links[i].professionalLinkUrl) {
        try {
          var url = new URL(links[i].professionalLinkUrl);

          if (url && url.hostname.endsWith('linkedin.com') && url.pathname.startsWith('/in/')) {
            var parts = url.pathname.split('/');

            if (parts.length > 2) {
              vanityName = parts[2];
              return {
                vanityName: vanityName,
                explicit: false
              };
            }
          }
        } catch (err) {}
      }
    }
  }

  return false;
}